import { FROZEN_EMPTY_ARRAY } from '@prophecy/utils/constants';
import { useOnce } from '@prophecy/utils/react/hooks';

import { useEnabledTranspilersAndLanguages } from '../../context/enabledTranspilers';

export function useSupportedSources() {
  const { supportedTranspilerType } = useEnabledTranspilersAndLanguages();
  return useOnce(() => {
    const supportedSources = new Set<string>();
    if (supportedTranspilerType) {
      supportedTranspilerType.forEach((transpiler) => {
        supportedSources.add(transpiler);
      });
      return [...supportedSources];
    }
    return FROZEN_EMPTY_ARRAY;
  });
}
